export default {
	"en": {
		"omsz": {
			"omsz": "Hungarian air quality network",
			"long_locale_code": "en_GB",
			"home_page_further_details_url": "/en/air-quality/aq-index-information",
			"sidebar_social": {
				"facebook": "https://www.facebook.com/HungaroMet/",
				"instagramm": "https://www.instagram.com/omsz_insta/",
				"twitter": "https://twitter.com/meteorologiahu",
				"youtube": "https://www.youtube.com/c/METHUidojarasjelentes"
			},
			"email": "legszennyezettseg@met.hu",
			"news": "News",
			"news_category": {
				"sub_title": "Related articles from <i>{category}</i> category",
				"1": "air-quality",
				"2": "general",
				"3": "modelling",
				"4": "emission"
			},
			"main_menu_slugs": {
				"air-quality": "air-quality",
				"modelling": "modelling",
				"emission": "emission"
			},
			"contacts": "Contact",
			"notation": "Notation",
			"buttons": {
				"previous_news": "Previous News",
				"additional_data": "Additional data",
				"more_info": "More information",
				"component": "Component",
				"download_forecast": "Download forecasts",
				"clear_filters": "Clear filters",
				"start_query": "Submit query",
				"csv_download": "CSV download"
			},
			"maps": {
				"globally": "Globally",
				"map_only_data": "The data on map is for information only!",
				"link_title": "Further data",
				"please_wait": "Please wait...",
				"data_not_available": "No data"
			},
			"legend": {
				"excellent": "Excellent",
				"good": "Good",
				"appropriate": "Appropriate",
				"contaminated": "Contaminated",
				"heavily_contaminated": "Heavily contaminated",
				"extremely_contaminated": "Extremely contaminated",
				"no_data": "no data available"
			},
			"footer_link": "legszennyezettseg.met.hu",
			"all_right_reserved": "All right reserved",
			"copyright": "Copyrights",
			"submenus": "Submenus",
			"pollution_forecast_title": "Expected evolution of air pollution",
			"monitoring": {
				"automatic": "Automatic monitoring network",
				"manual": "Manual monitoring network"
			},
			"placeholders": {
				"please_select": "Please select...",
				"please_wait": "Please wait..."
			},
			"air_quality_title": "Air quality",
			"eu_air_quality_label": "European air quality",
			"eu_air_quality_url": "https://www.eea.europa.eu/themes/air/air-quality-index",
			"evaluation_page_title": "OLM Evaluations",
			"air_quality_evaluation_page_title": "Air Quality Evaluation",
			"sub_title_air_quality_evaluation": "Further evaluations of the year",
			"epsgram_page_title": "EPSGRAM",
			"pbl_page_title": "PBL height",
			"si_index_page_title": "SI index",
			"404_title": "The content not available",
			"events_page_title": "Events",
			"emission_map_page_title": "Spatial data",
			"air_environment_evaluation_title": "Air environment evaluation",
			"air_environment_evaluation_back_link": "Go back to year picker",
			"emission_sectors": {
				"A": "Public Power",
				"B": "Industry",
				"C": "Other Stationary Comb",
				"D": "Fugitive",
				"E": "Solvents",
				"F": "Road Transport",
				"I": "Offroad",
				"J": "Waste",
				"K": "Agri Livestock",
				"L": "Agri Other",
				"N": "National total emission",
				"P": "Large point sources",
				"Q": "ETS installations"
			},
			"emission_components": {
				"bc": "BC",
				"cd": "Cd",
				"co": "CO",
				"hcb": "HCB",
				"hg": "Hg",
				"nh3": "NH₃",
				"nmvoc": "NMVOC",
				"nox": "NOₓ",
				"pahs": "PAHs",
				"pb": "Pb",
				"pcbs": "PCBs",
				"pcdd_pcdf": "dioxins/furans",
				"pm10": "PM₁₀",
				"pm2_5": "PM₂,₅",
				"sox": "SOₓ",
				"co2": "CO₂"
			},
			"modelling_components" : {
				"at": "Total",
				"as": "Sea salt",
				"ad": "Dust",
				"ao": "Biomass",
				"ac": "Soot",
				"au": "Sulfate",
			},
			"map_page_title": "Forecast with map",
			"modelling_page_title": "Modelling",
			"emission_page_title": "Emission",
			"errors": {
				"fetch_error": "Sorry, we've experienced errors during fetching data."
			}
		},
		"passwords": {
			"reset": "Your password has been reset!",
			"sent": "We have e-mailed your password reset link!",
			"throttled": "Please wait before retrying.",
			"token": "This password reset token is invalid.",
			"user": "We can't find a user with that e-mail address."
		},
		"auth": {
			"failed": "These credentials do not match our records.",
			"throttle": "Too many login attempts. Please try again in {seconds} seconds."
		},
		"pagination": {
			"previous": "&laquo; Previous",
			"next": "Next &raquo;"
		},
		"omsz-form": {
			"labels": {
				"components_area": "Competent Authority",
				"country": "County",
				"air_pollution_zone": "Air Quality Zone",
				"zone": "Zone",
				"city": "City",
				"town": "Town",
				"city_area": "Town",
				"settlement": "Settlement",
				"product": "Product",
				"stations": "Stations",
				"pollen": "Pollen",
				"model": "Model",
				"measured_components": "Measured components",
				"stat_date": "Start date",
				"end_date": "End date",
				"date_name": "Date",
				"limit_values": "Limit values",
				"no_data_available": "N/A",
				"date": {
					"year": "Year",
					"mounth": "Mounth",
					"day": "Day",
					"hour": "Hour",
					"minute": "Minute",
					"second": "Second"
				},
				"timebase": "Timebase",
				"type": "Type",
				"types": {
					"1": "monthly",
					"2": "heating semester",
					"3": "non-heating semester",
					"4": "whole year"
				},
				"pollutant": "Pollutant",
				"pollutants": "Pollutants",
				"emission_sector": "Emission sector",
				"area": "Area",
				"category": "Category"
			},
			"placeholders": {
				"select": "Please select",
				"select_city": "Search in cities",
				"select_station": "Search in stations",
				"select_element": "Search in components",
				"select_enter": "Select",
				"selected": "Selected",
				"remove": "Remove this value",
				"list_is_empty": "The list is empty"
			},
			"errors": {
				"max": "{max} options selected",
				"not_found": "Oops! No elements found",
				"no_result": "Sorry, no results",
				"not_response": "An error has occurred during processing, please try again later",
				"recaptcha_required": "Please verify that you are not a robot.",
				"recaptcha_failed": "Recaptcha validation failed. Please try again."
			},
			"message": {
				"information_only": "The data provided is to be considered as indicative only."
			}
		},
		"validation": {
			"accepted": "The {attribute} must be accepted.",
			"active_url": "The {attribute} is not a valid URL.",
			"after": "The {attribute} must be a date after {date}.",
			"after_or_equal": "The {attribute} must be a date after or equal to {date}.",
			"alpha": "The {attribute} may only contain letters.",
			"alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
			"alpha_num": "The {attribute} may only contain letters and numbers.",
			"array": "The {attribute} must be an array.",
			"before": "The {attribute} must be a date before {date}.",
			"before_or_equal": "The {attribute} must be a date before or equal to {date}.",
			"between": {
				"numeric": "The {attribute} must be between {min} and {max}.",
				"file": "The {attribute} must be between {min} and {max} kilobytes.",
				"string": "The {attribute} must be between {min} and {max} characters.",
				"array": "The {attribute} must have between {min} and {max} items."
			},
			"boolean": "The {attribute} field must be true or false.",
			"confirmed": "The {attribute} confirmation does not match.",
			"date": "The {attribute} is not a valid date.",
			"date_equals": "The {attribute} must be a date equal to {date}.",
			"date_format": "The {attribute} does not match the format {format}.",
			"different": "The {attribute} and {other} must be different.",
			"digits": "The {attribute} must be {digits} digits.",
			"digits_between": "The {attribute} must be between {min} and {max} digits.",
			"dimensions": "The {attribute} has invalid image dimensions.",
			"distinct": "The {attribute} field has a duplicate value.",
			"email": "The {attribute} must be a valid email address.",
			"ends_with": "The {attribute} must end with one of the following: {values}.",
			"exists": "The selected {attribute} is invalid.",
			"file": "The {attribute} must be a file.",
			"filled": "The {attribute} field must have a value.",
			"gt": {
				"numeric": "The {attribute} must be greater than {value}.",
				"file": "The {attribute} must be greater than {value} kilobytes.",
				"string": "The {attribute} must be greater than {value} characters.",
				"array": "The {attribute} must have more than {value} items."
			},
			"gte": {
				"numeric": "The {attribute} must be greater than or equal {value}.",
				"file": "The {attribute} must be greater than or equal {value} kilobytes.",
				"string": "The {attribute} must be greater than or equal {value} characters.",
				"array": "The {attribute} must have {value} items or more."
			},
			"image": "The {attribute} must be an image.",
			"in": "The selected {attribute} is invalid.",
			"in_array": "The {attribute} field does not exist in {other}.",
			"integer": "The {attribute} must be an integer.",
			"ip": "The {attribute} must be a valid IP address.",
			"ipv4": "The {attribute} must be a valid IPv4 address.",
			"ipv6": "The {attribute} must be a valid IPv6 address.",
			"json": "The {attribute} must be a valid JSON string.",
			"lt": {
				"numeric": "The {attribute} must be less than {value}.",
				"file": "The {attribute} must be less than {value} kilobytes.",
				"string": "The {attribute} must be less than {value} characters.",
				"array": "The {attribute} must have less than {value} items."
			},
			"lte": {
				"numeric": "The {attribute} must be less than or equal {value}.",
				"file": "The {attribute} must be less than or equal {value} kilobytes.",
				"string": "The {attribute} must be less than or equal {value} characters.",
				"array": "The {attribute} must not have more than {value} items."
			},
			"max": {
				"numeric": "The {attribute} may not be greater than {max}.",
				"file": "The {attribute} may not be greater than {max} kilobytes.",
				"string": "The {attribute} may not be greater than {max} characters.",
				"array": "The {attribute} may not have more than {max} items."
			},
			"mimes": "The {attribute} must be a file of type: {values}.",
			"mimetypes": "The {attribute} must be a file of type: {values}.",
			"min": {
				"numeric": "The {attribute} must be at least {min}.",
				"file": "The {attribute} must be at least {min} kilobytes.",
				"string": "The {attribute} must be at least {min} characters.",
				"array": "The {attribute} must have at least {min} items."
			},
			"not_in": "The selected {attribute} is invalid.",
			"not_regex": "The {attribute} format is invalid.",
			"numeric": "The {attribute} must be a number.",
			"password": "The password is incorrect.",
			"present": "The {attribute} field must be present.",
			"regex": "The {attribute} format is invalid.",
			"required": "The {attribute} field is required.",
			"required_if": "The {attribute} field is required when {other} is {value}.",
			"required_unless": "The {attribute} field is required unless {other} is in {values}.",
			"required_with": "The {attribute} field is required when {values} is present.",
			"required_with_all": "The {attribute} field is required when {values} are present.",
			"required_without": "The {attribute} field is required when {values} is not present.",
			"required_without_all": "The {attribute} field is required when none of {values} are present.",
			"same": "The {attribute} and {other} must match.",
			"size": {
				"numeric": "The {attribute} must be {size}.",
				"file": "The {attribute} must be {size} kilobytes.",
				"string": "The {attribute} must be {size} characters.",
				"array": "The {attribute} must contain {size} items."
			},
			"starts_with": "The {attribute} must start with one of the following: {values}.",
			"string": "The {attribute} must be a string.",
			"timezone": "The {attribute} must be a valid zone.",
			"unique": "The {attribute} has already been taken.",
			"uploaded": "The {attribute} failed to upload.",
			"url": "The {attribute} format is invalid.",
			"uuid": "The {attribute} must be a valid UUID.",
			"custom": {
				"attribute-name": {
					"rule-name": "custom-message"
				}
			},
			"attributes": []
		}
	},
	"hu": {
		"omsz": {
			"omsz": "Országos Légszennyezettségi Mérőhálózat",
			"long_locale_code": "hu_HU",
			"home_page_further_details_url": "/levegominoseg/informacio/aq-index-tajekoztato",
			"sidebar_social": {
				"facebook": "https://www.facebook.com/orszagosmeteorologiaiszolgalat/",
				"instagramm": "https://www.instagram.com/omsz_insta/",
				"twitter": "https://twitter.com/meteorologiahu",
				"youtube": "https://www.youtube.com/c/METHUidojarasjelentes"
			},
			"email": "legszennyezettseg@met.hu",
			"news": "Híreink",
			"news_category": {
				"sub_title": "Kapcsolódó cikkek a <i>{category}</i> kategóriából",
				"1": "levegőminőség",
				"2": "általános",
				"3": "modellezés",
				"4": "kibocsátás"
			},
			"main_menu_slugs": {
				"air-quality": "levegominoseg",
				"modelling": "modellezes",
				"emission": "kibocsatas"
			},
			"contacts": "Elérhetőség",
			"notation": "Jelmagyarázat",
			"buttons": {
				"previous_news": "Korábbi híreink",
				"additional_data": "További adatok",
				"more_info": "Bővebb információ",
				"component": "Komponens",
				"download_forecast": "Előrejelzés letöltése",
				"clear_filters": "Szűrők törlése",
				"start_query": "Lekérdezés",
				"csv_download": "CSV letöltése"
			},
			"maps": {
				"globally": "Globális",
				"map_only_data": "A térképen megjelenő adatok tájékoztató jellegűek!",
				"link_title": "További adatok",
				"please_wait": "Kérem, várjon...",
				"data_not_available": "Nincs adat"
			},
			"footer_link": "legszennyezettseg.met.hu",
			"all_right_reserved": "Minden jog fenntartva",
			"copyright": "Szerzői jogok",
			"submenus": "Almenük",
			"monitoring": {
				"automatic": "Automata mérőhálózat",
				"manual": "Manuális mérőhálózat"
			},
			"pollution_forecast_title": "Légszennyezettség várható alakulása",
			"placeholders": {
				"please_select": "Kérem válasszon...",
				"please_wait": "Kérem várjon..."
			},
			"air_quality_title": "Levegőminőség",
			"eu_air_quality_label": "Európai helyzet",
			"eu_air_quality_url": "https://www.eea.europa.eu/themes/air/air-quality-index",
			"evaluation_page_title": "OLM Értékelések",
			"air_quality_evaluation_page_title": "Levegőminőség értékelés",
			"sub_title_air_quality_evaluation": "Az év további értékelései",
			"epsgram_page_title": "EPSGRAM",
			"pbl_page_title": "PBL magasság",
			"si_index_page_title": "SI index",
			"404_title": "Nem található ilyen oldal",
			"events_page_title": "Programok",
			"emission_map_page_title": "Térbeli adatok",
			"air_environment_evaluation_title": "Levegőkörnyezeti tájékoztató",
			"air_environment_evaluation_back_link": "Vissza az évválasztóhoz",
			"emission_sectors": {
				"A": "Energiaipar",
				"B": "Ipari kibocsátások",
				"C": "Épületek kibocsátása",
				"D": "Szivárgó kibocsátások",
				"E": "Oldószerek",
				"F": "Közúti közlekedés",
				"I": "Egyéb mozgó források",
				"J": "Hulladékszektor kibocsátásai",
				"K": "Állattenyésztés",
				"L": "Növénytermesztés",
				"N": "Országos összkibocsátás",
				"P": "Nagy pontszerű források",
				"Q": "ETS létesítmények"
			},
			"emission_components": {
				"bc": "BC",
				"cd": "Cd",
				"co": "CO",
				"hcb": "HCB",
				"hg": "Hg",
				"nh3": "NH₃",
				"nmvoc": "NMVOC",
				"nox": "NOₓ",
				"pahs": "PAH-ok",
				"pb": "Pb",
				"pcbs": "PCB-k",
				"pcdd_pcdf": "dioxinok/furánok",
				"pm10": "PM₁₀",
				"pm2_5": "PM₂,₅",
				"sox": "SOₓ",
				"co2": "CO₂"
			},
			"modelling_components" : {
				"at": "Teljes",
				"as": "Tengeri só",
				"ad": "Por",
				"ao": "Biomassza",
				"ac": "Korom",
				"au": "Szulfát",
			},
			"map_page_title": "Térképes előrejelzés",
			"modelling_page_title": "Modellezés",
			"emission_page_title": "Kibocsátás",
			"errors": {
				"fetch_error": "Sajnáljuk, hiba történt az adatok lekérése során."
			}
		},
		"passwords": {
			"reset": "Your password has been reset!",
			"sent": "We have e-mailed your password reset link!",
			"throttled": "Please wait before retrying.",
			"token": "This password reset token is invalid.",
			"user": "We can't find a user with that e-mail address."
		},
		"auth": {
			"failed": "These credentials do not match our records.",
			"throttle": "Too many login attempts. Please try again in {seconds} seconds."
		},
		"pagination": {
			"previous": "&laquo; Previous",
			"next": "Next &raquo;"
		},
		"omsz-form": {
			"labels": {
				"components_area": "Illetékességi terület",
				"country": "Vármegye",
				"air_pollution_zone": "Légszennyezettségi zóna",
				"zone": "Zóna",
				"city": "Város",
				"town": "Város",
				"city_area": "Terület",
				"settlement": "Település",
				"product": "Produktum",
				"pollen": "Pollenfajta",
				"model": "Modell",
				"stations": "Mérőállomás",
				"measured_components": "Mért komponensek",
				"stat_date": "Kezdő időpont",
				"end_date": "Záró időpont",
				"date_name": "Dátum",
				"limit_values": "Határértékek",
				"no_data_available": "Nincs adat",
				"date": {
					"year": "Év",
					"mounth": "Hónap",
					"day": "Nap",
					"hour": "Óra",
					"minute": "Perc",
					"second": "Másodperc"
				},
				"timebase": "Időalap",
				"type": "Típus",
				"types": {
					"1": "havi",
					"2": "fűtési év",
					"3": "nem fűtési félév",
					"4": "teljes év"
				},
				"pollutant": "Szennyezőanyag",
				"pollutants": "Szennyező anyagok",
				"emission_sector": "Kibocsátási ágazat",
				"area": "Terület",
				"category": "Kategória"
			},
			"placeholders": {
				"select": "Kérjük válasszon",
				"select_city": "Keresés a városok között",
				"select_station": "Keresés a mérőállomások között",
				"select_element": "Keresés a komponensek között",
				"select_enter": "Kiválaszt",
				"selected": "Kiválasztva",
				"remove": "Eltávolítás",
				"list_is_empty": "A lista üres"
			},
			"errors": {
				"max": "{max} opciót lehet kijelölni",
				"not_found": "Sajnos nincs ilyen",
				"no_result": "Sajnáljuk, de nincs találat",
				"not_response": "Hiba a lekérdezés közben. Kérjük, próbálja később!",
				"recaptcha_required": "Kérjük jelölje be, hogy nem robot.",
				"recaptcha_failed": "A Recaptcha ellenőrzés sikertelen volt. Kérjük, próbálja meg újra."
			},
			"message": {
				"information_only": "Az adatok csak tájékoztató jellegűek."
			}
		},
		"validation": {
			"accepted": "The {attribute} must be accepted.",
			"active_url": "The {attribute} is not a valid URL.",
			"after": "A {attribute} mező értéke később kell legyen, mint {date}.",
			"after_or_equal": "The {attribute} must be a date after or equal to {date}.",
			"alpha": "The {attribute} may only contain letters.",
			"alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
			"alpha_num": "The {attribute} may only contain letters and numbers.",
			"array": "The {attribute} must be an array.",
			"before": "The {attribute} must be a date before {date}.",
			"before_or_equal": "The {attribute} must be a date before or equal to {date}.",
			"between": {
				"numeric": "The {attribute} must be between {min} and {max}.",
				"file": "The {attribute} must be between {min} and {max} kilobytes.",
				"string": "The {attribute} must be between {min} and {max} characters.",
				"array": "The {attribute} must have between {min} and {max} items."
			},
			"boolean": "The {attribute} field must be true or false.",
			"confirmed": "The {attribute} confirmation does not match.",
			"date": "A {attribute} mező értéke nem egy valós dátum.",
			"date_equals": "The {attribute} must be a date equal to {date}.",
			"date_format": "The {attribute} does not match the format {format}.",
			"different": "The {attribute} and {other} must be different.",
			"digits": "The {attribute} must be {digits} digits.",
			"digits_between": "The {attribute} must be between {min} and {max} digits.",
			"dimensions": "The {attribute} has invalid image dimensions.",
			"distinct": "The {attribute} field has a duplicate value.",
			"email": "The {attribute} must be a valid email address.",
			"ends_with": "The {attribute} must end with one of the following: {values}.",
			"exists": "The selected {attribute} is invalid.",
			"file": "The {attribute} must be a file.",
			"filled": "The {attribute} field must have a value.",
			"gt": {
				"numeric": "The {attribute} must be greater than {value}.",
				"file": "The {attribute} must be greater than {value} kilobytes.",
				"string": "The {attribute} must be greater than {value} characters.",
				"array": "The {attribute} must have more than {value} items."
			},
			"gte": {
				"numeric": "The {attribute} must be greater than or equal {value}.",
				"file": "The {attribute} must be greater than or equal {value} kilobytes.",
				"string": "The {attribute} must be greater than or equal {value} characters.",
				"array": "The {attribute} must have {value} items or more."
			},
			"image": "The {attribute} must be an image.",
			"in": "The selected {attribute} is invalid.",
			"in_array": "The {attribute} field does not exist in {other}.",
			"integer": "The {attribute} must be an integer.",
			"ip": "The {attribute} must be a valid IP address.",
			"ipv4": "The {attribute} must be a valid IPv4 address.",
			"ipv6": "The {attribute} must be a valid IPv6 address.",
			"json": "The {attribute} must be a valid JSON string.",
			"lt": {
				"numeric": "The {attribute} must be less than {value}.",
				"file": "The {attribute} must be less than {value} kilobytes.",
				"string": "The {attribute} must be less than {value} characters.",
				"array": "The {attribute} must have less than {value} items."
			},
			"lte": {
				"numeric": "The {attribute} must be less than or equal {value}.",
				"file": "The {attribute} must be less than or equal {value} kilobytes.",
				"string": "The {attribute} must be less than or equal {value} characters.",
				"array": "The {attribute} must not have more than {value} items."
			},
			"max": {
				"numeric": "The {attribute} may not be greater than {max}.",
				"file": "The {attribute} may not be greater than {max} kilobytes.",
				"string": "The {attribute} may not be greater than {max} characters.",
				"array": "The {attribute} may not have more than {max} items."
			},
			"mimes": "The {attribute} must be a file of type: {values}.",
			"mimetypes": "The {attribute} must be a file of type: {values}.",
			"min": {
				"numeric": "The {attribute} must be at least {min}.",
				"file": "The {attribute} must be at least {min} kilobytes.",
				"string": "The {attribute} must be at least {min} characters.",
				"array": "The {attribute} must have at least {min} items."
			},
			"not_in": "The selected {attribute} is invalid.",
			"not_regex": "The {attribute} format is invalid.",
			"numeric": "The {attribute} must be a number.",
			"password": "The password is incorrect.",
			"present": "The {attribute} field must be present.",
			"regex": "The {attribute} format is invalid.",
			"required": "The {attribute} field is required.",
			"required_if": "The {attribute} field is required when {other} is {value}.",
			"required_unless": "The {attribute} field is required unless {other} is in {values}.",
			"required_with": "The {attribute} field is required when {values} is present.",
			"required_with_all": "The {attribute} field is required when {values} are present.",
			"required_without": "The {attribute} field is required when {values} is not present.",
			"required_without_all": "The {attribute} field is required when none of {values} are present.",
			"same": "The {attribute} and {other} must match.",
			"size": {
				"numeric": "The {attribute} must be {size}.",
				"file": "The {attribute} must be {size} kilobytes.",
				"string": "The {attribute} must be {size} characters.",
				"array": "The {attribute} must contain {size} items."
			},
			"starts_with": "The {attribute} must start with one of the following: {values}.",
			"string": "The {attribute} must be a string.",
			"timezone": "The {attribute} must be a valid zone.",
			"unique": "The {attribute} has already been taken.",
			"uploaded": "The {attribute} failed to upload.",
			"url": "The {attribute} format is invalid.",
			"uuid": "The {attribute} must be a valid UUID.",
			"custom": {
				"attribute-name": {
					"rule-name": "custom-message"
				}
			},
			"attributes": []
		}
	}
}
